/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';

interface ShowTypeMenuItem {
  title: string;
  iconName: string;
  type: 'inbox' | 'passed' | 'done';
}

@Component({
  standalone: false,
  moduleId: module.id ? String(module.id) : undefined,
  selector: 'gh-todo-type-menu',
  templateUrl: 'todo-type-menu.component.html',
  styleUrls: ['todo-type-menu.component.scss'],
})
export class TodoTypeMenuComponent {
  @Input() currentShowType: string = 'inbox';
  @Input() menuItems: ShowTypeMenuItem[] = [];
  @Output() changeShowType: EventEmitter<any> = new EventEmitter();

  noop(): void {}

  onChangeShowType(type: string): void {
    this.changeShowType.emit(type);
  }

  iconName(name: string): string {
    return `gh:${name}`;
  }

}
